import { CheckCircle2, User } from "lucide-react";

interface ResourceUser {
  full_name?: string | null;
  email: string;
}

interface Props {
  createdBy?: ResourceUser | null | undefined;
  reviewedBy?: ResourceUser | null | undefined;
}

export function ResourceUserBadges({ createdBy, reviewedBy }: Props) {
  const getDisplayName = (user: ResourceUser | undefined | null): string => {
    if (!user) return "";
    return user.full_name ?? user.email;
  };

  return (
    <div className="flex flex-wrap gap-3 text-sm text-muted-foreground mt-2">
      {createdBy && (
        <div className="flex items-center gap-2">
          <User className="h-4 w-4" />
          <span>
            Creado por: <span className="font-medium">{getDisplayName(createdBy)}</span>
          </span>
        </div>
      )}
      {reviewedBy && (
        <div className="flex items-center gap-2">
          <CheckCircle2 className="h-4 w-4" />
          <span>
            Revisado por: <span className="font-medium">{getDisplayName(reviewedBy)}</span>
          </span>
        </div>
      )}
    </div>
  );
}